import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TranslationState } from './types'

const initialState: TranslationState = {
  isTranslation: false,
  isLocalization: false,
  translationFields: [],
  prepickedLanguagesForLocalize: [],
}

const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    setIsTranslation(state, action: PayloadAction<boolean>) {
      state.isTranslation = action.payload
    },
    setIsLocalization(state, action: PayloadAction<boolean>) {
      state.isLocalization = action.payload
    },
    setIsTranslationSafe(state) {
      if (state.translationFields.length && !state.isTranslation) {
        state.isTranslation = true
      } else if (!state.translationFields.length && state.isTranslation) {
        state.isTranslation = false
      }
    },
    setTranslationFields(state, action: PayloadAction<string[]>) {
      state.translationFields = action.payload
    },
    resetTranslationFields(state) {
      state.translationFields = initialState.translationFields
    },
    setPrepickedLanguagesForLocalize(state, action: PayloadAction<string[]>) {
      state.prepickedLanguagesForLocalize = action.payload
    },
  },
})

export default translationSlice.reducer

export const {
  setIsTranslation,
  setIsTranslationSafe,
  setTranslationFields,
  resetTranslationFields,
  setIsLocalization,
  setPrepickedLanguagesForLocalize,
} = translationSlice.actions
